import * as Colors from '../colors';
import { MuiComponent } from './type';

export const MuiTextField: MuiComponent<"MuiTextField"> = {
  defaultProps: {
    InputLabelProps: {
      shrink: true, // Prevent label from moving inside input
    },
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      backgroundColor: '#1F2228',
      borderRadius: '8px',
      border: '1px solid #353A41',
      
      'input': {
        fontSize: 14,
        padding: '8px 12px',
        fontWeight: '400',
        lineHeight: 'inherit',
        
        // placeholder
        ['::placeholder']: {
          color: Colors.PlaceholderGray,
        },
      },

      // Conditionally add marginTop if label exists
      marginTop: ownerState.label ? '34px' : '0px',

      '& .MuiInputLabel-root': {
        marginTop: '-24px',
        marginLeft: '-15px',
        color: Colors.LightGray,
      },

      '& .MuiOutlinedInput-notchedOutline': {
        display: 'none',
      },

      '&:hover': {
        borderColor: `${Colors.BorderPurple} !important`,
      },

      '&.Mui-focused': {
        borderColor: `${Colors.BorderPurple} !important`,
        borderWidth: '1px !important',
      },
    }),
  },
  variants: [
    {
      props: { variant: "outlined" },
      style: {
        '& > .MuiOutlinedInput-root': {
          backgroundColor: 'transparent',
          border: 0
        },
      },
    },
  ],
};

export const MuiOutlinedInput: MuiComponent<"MuiOutlinedInput"> = {
  styleOverrides: {
    root: {
      backgroundColor: '#1F2228',
      borderRadius: '8px',
      border: '1px solid #353A41',

      '& .MuiOutlinedInput-notchedOutline': {
        display: 'none',
      },

      '&:hover': {
        borderColor: `${Colors.BorderPurple} !important`,
      },

      '&.Mui-focused': {
        borderColor: `${Colors.BorderPurple} !important`,
      },
    },
  },
};
